import { breakPoints, useMediaQuery } from '@gcl/react-core';

export const useBreakPoints = () => {
  const isSm = useMediaQuery(breakPoints.breakpointSm);
  const isXs = useMediaQuery(breakPoints.breakpointXs);
  const isMd = useMediaQuery(breakPoints.breakpointMd);
  const isLg = useMediaQuery(breakPoints.breakpointLg);
  const isXl = useMediaQuery(breakPoints.breakpointXl);
  const isXxl = useMediaQuery(breakPoints.breakpointXXl);

  return {
    isSm,
    isXs,
    isMd,
    isLg,
    isXl,
    isXxl,
  };
};
